<template>
    <div>
        <div class="banner2">
            <img src="../assets/img/banner6.jpg" alt="banner" />
        </div>

        <div class="block">
            <div class="center">
                <div class="lyb">
                    <div class="title">联系方式</div>
                    <div class="contact">
                        <span><i class="icon icon_phone"></i>服务热线：400-655-1155</span>
                        <!-- <span><i class="icon icon_fax"></i>传真：****-****</span> -->
                        <!-- <span><i class="icon icon_mail"></i>企业邮箱：****@***.com</span> -->
                        <span><i class="icon icon_location"></i>公司地址：哈尔滨市松北区智谷二街3043号龙岗产业园9B栋</span>
                        <div class="allmap"></div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { baiduMap } from "../assets/js/baiduMap.js";
import { LiuYanBan_add, LiuYanBan_code } from "../request/api"; // 导入接口

export default {
    name: 'Home',
    data() {
        return {
            title: '公司简介',
            sub_title: '',
            windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight, //实时屏幕高度

            form: {
                title: '',
                content: '',
                telephone: '',
                code: '',
                img: '/captcha/captchaImage?type=math',
            }
        };
    },
    created() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        this.LiuYanBna_code_data();
    },
    mounted() {
        window.onresize = () => {
            //页面改变尺寸时
            return (() => {
                this.windowWidth = document.documentElement.clientWidth;
                this.windowHeight = document.documentElement.clientHeight;
            })();
        };
        const ak = "fXWl1PNElp50jGqOpbrKGlTqADjSDuyz";
        baiduMap(ak).then(() => {
            this.createMap(); // 创建地图
        });
    },
    methods: {
        goTo(e) {
            this.$router.push(e);
        },
        LiuYanBna_code_data() {
            LiuYanBan_code({
            }).then((res) => {
                this.form.img = "http://www.corner.com.cn" + this.form.img;
            });
        },
        LiuYanBanForm() {
            console.log(JSON.stringify(this.form));
            LiuYanBan_add({
                title: this.form.title,
                content: this.form.content,
                telephone: this.form.telephone,
                code: this.form.code,
            }).then((res) => {
                if (res.code == 0) {
                    alert(res.msg);
                    this.form.title = '';
                    this.form.content = '';
                    this.form.telephone = '';
                    this.form.code = '';
                } else {
                    alert(res.msg);
                };
            });

        },
        createMap() {
            //创建百度地图
            var map = new BMap.Map("allmap"); //根据id创建地图画布
            map.enableScrollWheelZoom(true); //开启鼠标滚动放大缩小

            var point2 = new BMap.Point(126.484501, 45.816006);
            map.centerAndZoom(point2, 17);
            var marker2 = new BMap.Marker(point2);
            map.addOverlay(marker2);
            var opts2 = {
                width: 300,
                height: 100,
                title: "哈尔滨凯纳科技股份有限公司",
                message: "哈尔滨市松北区智谷二街3043号龙岗产业园9B栋",
            };
            var infoWindow2 = new BMap.InfoWindow("地址：哈尔滨市松北区智谷二街3043号龙岗产业园9B栋", opts2);
            map.openInfoWindow(infoWindow2, point2);
            marker2.addEventListener("click", function () {
                map.openInfoWindow(infoWindow2, point2);
            });
        },
    },
};
</script>
<style lang="less" scoped>
.allmap {
    margin: 5px;
    vertical-align: top;
    min-height: 500px;
    background-color: #fcfcfc;
    background-position: center;
    background-size: auto 700px;
    background-image: url('../assets/img/map.jpg');
}
</style>



// WEBPACK FOOTER //
// src/pages/Map.vue